var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    borderTop: ("solid 5px " + _vm.color),
    width: _vm.size,
    height: _vm.size,
    minWidth: _vm.size,
    minHeight: _vm.size,
  }),attrs:{"id":"spinner"}})}
var staticRenderFns = []

export { render, staticRenderFns }